module.exports = __webpack_public_path__ + "img/zamena.18444916.png";